import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import config from '../config.js';
import UserContext from '../components/common/UserContext.js';

// css
import '../assets/css/FlexibleSpendingAccounts.css';

// components
import PageHeader from '../components/common/PageHeader.js';
import Spinner from '../components/common/Spinner.js';
import FlexibleSpendingAccountsGrid from '../components/FlexibleSpendingAccounts/FlexibleSpendingAccountsGrid.js';
import {useSupportContext} from "../components/common/SupportContext";

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {
    flexibleSpendingAccountsKey,
    myFlexibleSpendingAccountsKey,
    noActiveAgreementsKey,
    mainMessages
} from '../assets/text/MultilingualText.js';

function FSASummary(props) {
    const {
        siteLanguageDefault,
        accessToken
    } = useContext(UserContext);
    const { dispatch } = useSupportContext();
    const localization = useLocalization();
    const [isLoading, setIsLoading] = useState(false);

    const [agreements, setAgreements] = useState([]);

    const getAgreements = () => {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        };
        setIsLoading(true);
        axios.get(
            config.fsa.GET_FLEXIBLE_SPENDING_ACCOUNTS,
            {headers: headers}
        )
            .then((response) => {
                if (response.status === 200) {
                    let data = response.data;
                    data.forEach(agreement => {
                        agreement.expired = agreement.status !== "ACTIVE";
                        agreement.percent = `${((Number(agreement.overdraft_budget) / Number(agreement.budget)) * 100).toFixed(2)}%`
                        // sets date correctly for filtering
                        if (agreement.start_date !== null) {
                            agreement.start_date = new Date(agreement.start_date.replace("T", " ").replace(/-/g, "/"));
                        }
                        if (agreement.end_date !== null) {
                            agreement.end_date = new Date(agreement.end_date.replace("T", " ").replace(/-/g, "/"));
                        }
                    });
                    setAgreements(data);
                }
            })
            .catch((error) => {
                console.log("ERROR: Failed to GET Flexible Spending Accounts", error);
                setAgreements([]);
            })
            .finally(() => {
                setIsLoading(false);
            })

    }

    useEffect(() => {
        getAgreements();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    //    console.log("agreements", agreements);
    // }, [agreements]); // eslint-disable-line react-hooks/exhaustive-deps

    // Support Context Metadata
    // Set Module and Step values on page load
    useEffect(() => {
        dispatch({ type: 'MODULE_LOAD', payload: {module: 'FSA Summary', step: ''}});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {isLoading ? <Spinner/> : <></>}
            <PageHeader/>
            <div className={"ksm-page-container"}>
                <div
                    className={"k-h3"}
                >
                    {localization.toLanguageString(flexibleSpendingAccountsKey, mainMessages[siteLanguageDefault][flexibleSpendingAccountsKey])}
                </div>
                <div
                    className={"k-h5"}
                >
                    {localization.toLanguageString(myFlexibleSpendingAccountsKey, mainMessages[siteLanguageDefault][myFlexibleSpendingAccountsKey])}
                </div>
                {!isLoading && !agreements.length && (
                    <div
                        style={{
                            color: "var(--color-alert-danger-base)",
                            fontWeight: 600,
                            marginBottom: "0.5rem",
                        }}
                    >
                        {localization.toLanguageString(noActiveAgreementsKey, mainMessages[siteLanguageDefault][noActiveAgreementsKey])}
                    </div>
                )}
                <div style={{marginBottom: "1.25em"}}>
                    <FlexibleSpendingAccountsGrid agreements={agreements}/>
                </div>
            </div>
        </>
    );
}


export default FSASummary;

